import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyABmOaLV8WtEKOfJ1u9yomdcqECG3mTIUA",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "lagoona-calendly.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "lagoona-calendly",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "lagoona-calendly.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "259032628854",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:259032628854:web:f67aa7b098ac1a1e14e957",
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-HBSKNLPES2",
};

const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
}, "default");
export const auth = getAuth(app);
export const storage = getStorage(app);
// Par défaut un envoi hors ligne réessaie 10 min avant d'échouer : on abrège pour
// que la finalisation QualiRépar passe vite en attente du retour du réseau.
storage.maxUploadRetryTime = 60_000;
export default app;
